<template lang="pug">
b-modal#getVoucherList(
  ref="getVoucherList"
  :title="$t('ui.combine.get_voucher_list')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div
      b-form-group(:label="$t('ui.voucher')").mb-3
        .row.w-100
          .form-group.col-md-3.col-2.mb-1
            b-input-group(size="sm")
              b-input-group-text(slot="prepend")
                span {{ $t('ui.status') }}
              b-form-select(v-model="voucherStatus" @change="getVoucherList(true)" :disabled="loading" size="sm")
                option(value="") {{ $t('ui.all') }}
                option(value="REDEEMED") {{ $t('ui.redeemed') }}
                option(value="ACTIVE") {{ $t('ui.active') }}
          .form-group.col-md-9.col-10.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-search"
              :text="$t('ui.search')"
              type="button"
              @click="getLabelList(true)"
              variant="primary"
              size="sm"
            )
        .row.mt-3
          .col-10.mb-1
            b-pagination.float-left(
              size="sm"
              hide-ellipsis
              :total-rows="totalRowVoucherList"
              :per-page="getPageSizeVoucherList"
              v-model="currentPageVoucherList"
              @input="changedPage($event)"
            )
          .col-2.mb-1
            b-input-group(:prepend="$t('ui.page_size')" size="sm")
              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSizeVoucherList" @input="changedPageSize" size="sm")
          .col
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                thead.thead-light
                  tr
                    th.text-center(width="3%")
                      span #
                    th(width="8%")
                      span {{ $t('ui.code') }}
                    th.text-right(width="10%" @click="sortOrder('amount')")
                      span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                      .float-right
                        i(:class="changeSortKey('amount')")
                    th.text-center(width="10%"  @click="sortOrder('status')")
                      span(:title="$t('ui.status')")  {{ $t('ui.status') }}
                      .float-right
                        i(:class="changeSortKey('status')")
                    th(width="10%" @click="sortOrder('redeemed_by')")
                      span(:title="$t('ui.redeemed_by')")  {{ $t('ui.redeemed_by') }}
                      .float-right
                        i(:class="changeSortKey('redeemed_by')")
                    th(width="15%" @click="sortOrder('redeemed_by_parent')")
                      span(:title="$t('ui.redeemed_by_operator')")  {{ $t('ui.redeemed_by_operator') }}
                      .float-right
                        i(:class="changeSortKey('redeemed_by_parent')")
                    th.text-right(width="12%" @click="sortOrder('redeemed_at')")
                      span(:title="$t('ui.redeemed_at')")  {{ $t('ui.redeemed_at') }}
                      .float-right
                        i(:class="changeSortKey('redeemed_at')")
                    th.text-right(width="12%" @click="sortOrder('created_at')")
                      span(:title="$t('ui.created_at')")  {{ $t('ui.created_at') }}
                      .float-right
                        i(:class="changeSortKey('created_at')")

                tbody
                  tr(v-if="voucherList.length == 0")
                      td(colspan="10").text-center
                        span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in voucherList")
                    td.text-center
                      span(:title="index + 1") {{ index + 1 }}
                    td
                      span(:title="item.code") {{ item.code }}
                    td.text-right.font-weight-bold
                      span(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                    td.text-center
                      //- span(:title="item.status") {{ item.status }}
                      span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                    td
                      span(:title="item.redeemed_by") {{ item.redeemed_by }}
                    td
                      span(:title="item.redeemed_by_parent") {{ item.redeemed_by_parent }}
                    td.text-right
                      span(v-if="item.redeemed_at" :title="$moment(item.redeemed_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.redeemed_at).format('YYYY-MM-DD, HH:mm:ss') }}
                    td.text-right
                      span(v-if="item.created_at" :title="$moment(item.created_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_at).format('YYYY-MM-DD, HH:mm:ss') }}
    .row
      .col-12
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import BankGroupLookup from "@/library/BankGroupLookup";
import BankAccType from "@/library/BankAccType";


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    BankAccType,
    BankGroupLookup
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      account_id: '',
      voucherList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      voucherStatus: '',
      currentPageVoucherList: 1,
      totalRowVoucherList: 0,
      getPageSizeVoucherList: 10,
      sortKeyVoucherList: "created_at",
      sortTypeVoucherList: "desc"
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKeyVoucherList == key)
        this.sortTypeVoucherList = this.sortTypeVoucherList == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKeyVoucherList = key;
        this.sortTypeVoucherList = 'asc';
      }

      this.getVoucherList(true);
    },
    changeSortKey(key) {
      if (this.sortKeyVoucherList != key)
        return 'fas fa-sort';
      else if (this.sortKeyVoucherList == key && this.sortTypeVoucherList == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKeyVoucherList == key && this.sortTypeVoucherList == 'desc')
        return 'fa fa-sort-down';
    },
    getVoucherList: function() {
      let url = config.voucherListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.item.account_id,
        voucher_status: this.voucherStatus,
        sort_key: this.sortKeyVoucherList,
        sort_type: this.sortTypeVoucherList,
        page_number: this.currentPageVoucherList,
        page_size: this.getPageSizeVoucherList
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.voucherList = response.data.dt;
                this.totalRowVoucherList = this.voucherList.length > 0 ? this.voucherList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.account_id;
      this.voucherStatus = ''
      this.currentPageVoucherList = 1
      this.totalRowVoucherList = 0
      this.getPageSizeVoucherList = 10
      this.getVoucherList();
    },
    changedPageSize: function(pageSize) {
      // this.$store.dispatch("layout/setPageSizeMemberLabel", pageSize);
      this.getPageSizeVoucherList = pageSize
      this.currentPageVoucherList = 1;
      this.getVoucherList(true);
    },
    changedPage: function(pageNo) {
      this.currentPageVoucherList = pageNo;
      this.getVoucherList();
    },
  }
};
</script>
